var React = require('react');

function IconWarningSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M951.3 883.3L520.7 139.4c-3.9-6.7-13.5-6.7-17.3 0L72.7 883.3c-3.9 6.7 1 15 8.7 15h861.3c7.7 0 12.5-8.3 8.6-15zM544.8 742.2c0 5.5-4.5 10-10 10h-45.5c-5.5 0-10-4.5-10-10v-61.5c0-5.5 4.5-10 10-10h45.5c5.5 0 10 4.5 10 10v61.5zm0-132.1c0 5.5-4.5 10-10 10h-44.5c-5.5 0-10-4.5-10-10V467.2c0-5.5 4.5-10 10-10h44.5c5.5 0 10 4.5 10 10v142.9z"}));
}

IconWarningSolid.displayName = "IconWarningSolid";

IconWarningSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconWarningSolid;

IconWarningSolid.default = IconWarningSolid;
